import { AccountTransferViewGetCollectionConfigs } from './AccountTransferView';

export { AccountTransferViewGetCollectionConfigs };
